import { Component, Inject } from '@angular/core';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISelection } from 'pbc.types';

import { ErforderlichesDokumentsQueryFilterConfig, IErforderlichesDokumentsQueryShapes } from 'fa-kt.types';
import { ErforderlichesDokumentsService } from '../service';

@Component({
  selector: 'fa-kt-erforderliches-dokuments-filter',
  templateUrl: './erforderliches-dokuments-filter.component.html',
  styleUrls: ['./erforderliches-dokuments-filter.component.css'],
})
export class ErforderlichesDokumentsFilterComponent {
  readonly subscriptions: Subscription[] = [];

  ErforderlichesDokumentsFilterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public erforderlichesDokuments: ErforderlichesDokumentsService,
  ) {
    this.ErforderlichesDokumentsFilterConfig = ErforderlichesDokumentsQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.erforderlichesDokuments.shapes$.subscribe((shapes: IErforderlichesDokumentsQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.ErforderlichesDokumentsFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.ErforderlichesDokumentsFilterConfig[index].selections = shapes;
  }
}
